
export default (Vue , options = {})=>{
    require('intersection-observer');
    const intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((item) => {
            if (item.isIntersecting) {
                if (item.target.func) {
                    item.target.func()
                }
                
                // 替换成功后，停止观察该dom
                intersectionObserver.unobserve(item.target);
            }
        })
      }, {
          rootMargin: "20px 0px" // 提前150px进入可视区域时就加载图片，提高用户体验
        });
    //Vue 指令最终的方法
    const addListener = (ele,binding) =>{
        ele.func = binding.value
        intersectionObserver.observe(ele)
    }

    Vue.directive('lazyFunc',{
        inserted:addListener,
        // update:addListener
    })
}